import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BreadcrumbComponent} from './breadcrumb/breadcrumb.component';
import {NdMedicationOrderComponent} from '../modals/patient/p-note-dialog/nd-medication-order/nd-medication-order.component';
import {CalendarComponent} from './calendar/calendar.component';
import {NdStatusUpdatedComponent} from '../modals/patient/p-note-dialog/nd-status-updated/nd-status-updated.component';
import {NdMedicationReconciliationComponent} from '../modals/patient/p-note-dialog/nd-medication-reconciliation/nd-medication-reconciliation.component';
import {NdVirtualAppointmentComponent} from '../modals/patient/p-note-dialog/nd-virtual-appointment/nd-virtual-appointment.component';
import {DropdownComponent} from './dropdown/dropdown.component';
import {MissingDataComponentComponent} from '../../components/missing-data-component/missing-data-component.component';
import {PlanHeaderComponent} from './plan-header/plan-header.component';
import {TimeframeComponent} from './timeframe/timeframe.component';
import {PatientSummaryTabsComponent} from './patient-summary-tabs/patient-summary-tabs.component';
import {BirthDayCalendarComponent} from './birth-day-calendar/birth-day-calendar.component';
import {EditableComponent} from './editable/editable.component';
import {OrgAccountInfoComponent} from '../../modules/organizations/org-overview/components/org-account-info/org-account-info.component';
import {SpecialtiesChipComponent} from './specialties-chip/specialties-chip.component';
import {GoogleAutocompleteComponent} from './google/google-autocomplete/google-autocomplete.component';
import {PatientEnrollAccordionComponent} from '../modals/patient/p-enroll-dialog/patient-enroll-accordion/patient-enroll-accordion.component';
import {CarePlanTasksOverviewComponent} from './care-plan-tasks-overview/care-plan-tasks-overview.component';
import {UnderConstructionComponent} from '../../components/under-construction/under-construction.component';
import {VersionCheckDialogComponent} from './version-check-dialog/version-check-dialog.component';
import {SnackbarComponent} from './snackbar/snackbar.component';
import {CarePlanGroupedTasksComponent} from './care-plan-grouped-tasks/care-plan-grouped-tasks.component';
import {TeamMemberDashboardComponent} from '../../components/main/team-members/dashboard/dashboard.component';
import {SkeletonLoaderComponent} from './skeleton-loader/skeleton-loader.component';
import {MedicationInteractionsComponent} from './medication-interactions/medication-interactions.component';
import {ClinicAccountInfoComponent} from '../../modules/organizations/org-overview/components/clinic-account-info/clinic-account-info.component';
import {ButtonLoadingSpinnerComponent} from './button-loading-spinner/button-loading-spinner.component';
import {NdAssessmentComponent} from '../modals/patient/p-note-dialog/nd-assessment/nd-assessment.component';
import {UploadIconComponent} from './upload-icon/upload-icon.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoadingModule} from '../../modules/loading/loading.module';
import {PipesModule} from '../../core/pipes/pipes.module';
import {ImageCropperModule} from 'ngx-image-cropper';
import {MaterialModules} from '../../core/imports/materialModules';
import {GoogleMapsModule} from '@angular/google-maps';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {CustomErrorComponent} from './custom-error/custom-error.component';
import {LanguageDropdownComponent} from './language-dropdown/language-dropdown.component';
import {DirectivesModule} from '../../core/directives/directives.module';
import {DatepickerSepComponent} from './datepicker-sep/datepicker-sep.component';
import {OverlayModule} from '@angular/cdk/overlay';
import {TranslateModule} from '@ngx-translate/core';
import {GanntViewComponent} from './calendar/gannt-view/gannt-view.component';
import {SelectAppointmentDateComponent} from './appointment/select-appointment-date/select-appointment-date.component';
import {SelectAppointmentSlotComponent} from './appointment/select-appointment-slot/select-appointment-slot.component';
import {GeocodeAddressComponent} from './google/geocode-address/geocode-address.component';
import { DoctorInformationComponent } from './doctor-information/doctor-information.component';
import { LedTypeComponent } from './led-type/led-type.component';
import {NgxMaskModule} from 'ngx-mask';
import { AppointmentSlotComponent } from '../appointment2.0/appointment-slot/appointment-slot.component';
import { AppointmentDateComponent } from '../appointment2.0/appointment-date/appointment-date.component';
import { AppointmentFilterComponent } from '../appointment2.0/appointment-filter/appointment-filter.component';
import { ConfirmAppointmentComponent } from '../appointment2.0/confirm-appointment/confirm-appointment.component';

@NgModule({
  declarations: [
    MissingDataComponentComponent,
    DropdownComponent,
    PlanHeaderComponent,
    TimeframeComponent,
    PatientSummaryTabsComponent,
    UnderConstructionComponent,
    ButtonLoadingSpinnerComponent,
    TeamMemberDashboardComponent,
    UploadIconComponent,
    BirthDayCalendarComponent,
    BreadcrumbComponent,
    SnackbarComponent,
    SpecialtiesChipComponent,
    MedicationInteractionsComponent,
    CarePlanGroupedTasksComponent,
    CarePlanTasksOverviewComponent,
    EditableComponent,
    VersionCheckDialogComponent,
    PatientEnrollAccordionComponent,
    GoogleAutocompleteComponent,
    SkeletonLoaderComponent,
    OrgAccountInfoComponent,
    ClinicAccountInfoComponent,
    NdAssessmentComponent,
    NdVirtualAppointmentComponent,
    NdMedicationReconciliationComponent,
    NdStatusUpdatedComponent,
    NdMedicationOrderComponent,
    CalendarComponent,
    CustomErrorComponent,
    LanguageDropdownComponent,
    DatepickerSepComponent,
    GanntViewComponent,
    SelectAppointmentDateComponent,
    SelectAppointmentSlotComponent,
    GeocodeAddressComponent,
    DoctorInformationComponent,
    LedTypeComponent,
    AppointmentSlotComponent,
    AppointmentDateComponent,
    AppointmentFilterComponent,
    ConfirmAppointmentComponent
  ],
  imports: [
    CommonModule,
    LoadingModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    ImageCropperModule,
    MaterialModules,
    GoogleMapsModule,
    DirectivesModule,
    NgxSkeletonLoaderModule,
    NgxMaskModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    OverlayModule,
    TranslateModule,
  ],
  exports: [
    MissingDataComponentComponent,
    DropdownComponent,
    PlanHeaderComponent,
    TimeframeComponent,
    PatientSummaryTabsComponent,
    UnderConstructionComponent,
    ButtonLoadingSpinnerComponent,
    TeamMemberDashboardComponent,
    UploadIconComponent,
    BirthDayCalendarComponent,
    BreadcrumbComponent,
    SnackbarComponent,
    SpecialtiesChipComponent,
    MedicationInteractionsComponent,
    CarePlanGroupedTasksComponent,
    CarePlanTasksOverviewComponent,
    EditableComponent,
    VersionCheckDialogComponent,
    PatientEnrollAccordionComponent,
    GoogleAutocompleteComponent,
    SkeletonLoaderComponent,
    OrgAccountInfoComponent,
    ClinicAccountInfoComponent,
    NdAssessmentComponent,
    NdVirtualAppointmentComponent,
    NdMedicationReconciliationComponent,
    NdStatusUpdatedComponent,
    NdMedicationOrderComponent,
    CalendarComponent,
    LanguageDropdownComponent,
    DatepickerSepComponent,
    SelectAppointmentDateComponent,
    SelectAppointmentSlotComponent,
    GeocodeAddressComponent,
    LedTypeComponent,

    // Modules
    LoadingModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    ImageCropperModule,
    MaterialModules,
    GoogleMapsModule,
    CalendarModule,
    DirectivesModule,
    DoctorInformationComponent,
    AppointmentSlotComponent,
    AppointmentDateComponent,
    AppointmentFilterComponent,
    ConfirmAppointmentComponent
  ],
  entryComponents: [SnackbarComponent, VersionCheckDialogComponent],
})
export class SharedComponentsModule {}
